import { Navigate } from '@exam-center/router';
import { dayjs } from '@shared/utils';

export default function ExamDistributionYearPage() {
  const currentYear = dayjs().year();

  // Navigate User to Current Year Exam Distribution Page
  return (
    <Navigate
      to='/admin/exam-distribution/year/:year'
      params={{ year: currentYear.toString() }}
      replace
    />
  );
}
